import { UserAddressesService, type PutUserAddressAdminRequest } from '@/backend/market'
import { UserAddressRepository } from '../../domain/repositories/UserAddressRepository'
import { UserAddressModel } from '../models/UserAddressModel'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { UserAddressEntity } from '../../domain/entities/UserAddressEntity'
import type { UpdateUserAddressEntity } from '../../domain/entities/UpdateUserAddressEntity'
import { UpdateUserAddressModel } from '../models/UpdateUserAddressModel'

export class UserAddressRepositoryImpl implements UserAddressRepository {
  async getUserAddress(filterData: {
    regionId?: number
    userId?: string
    page?: number
    limit?: number
  }): Promise<PaginateEntity<UserAddressEntity[]> | { error: true }> {
    try {
      const response = await UserAddressesService.getUserAddressesAdmin(filterData)
      const userAddressModel = response.items?.map(
        (item) => new UserAddressModel(item as UserAddressEntity)
      )
      const result = new PaginateEntity<UserAddressModel[]>(response, userAddressModel)

      return result
    } catch {
      return { error: true }
    }
  }
  async updateUserAddress(
    id: number,
    updateUserAddressData: UpdateUserAddressEntity
  ): Promise<{ success: true } | { error: true }> {
    const updateUserAddressModel = new UpdateUserAddressModel(updateUserAddressData)
    try {
      await UserAddressesService.putUserAddressAdmin({
        id,
        requestBody: updateUserAddressModel as PutUserAddressAdminRequest
      })

      return { success: true }
    } catch {
      return { error: true }
    }
  }
}
